export default __webpack_public_path__ + "static/media/mb1.1ed301a5.jpg";